// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      activityImpactCriticailityOptions: [
        "Startup",
        "Shutdown",
        "Delay",
        "Production",
        "Reliablity",
        "Safety",
        "Major"
      ],
      // eslint-disable-next-line
      conditionForActivityOptions: [
        "Online",
        "Offline",
        "Isolate",
        "Factory",
        "Special"
      ]
    };
  }
};
